module.exports = function() {
  return new Worker(__webpack_public_path__ + "295d5a6bda95058a8218.worker.js");
};